import React from "react";
import back from "../image/back.png";

const Concurry = () => {
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };

  return (
    <div className="bg-white rounded-lg">
      {/* Background Section */}
      <div
        className="bg-cover bg-center h-64 flex flex-col justify-center items-center text-center px-4"
        style={{
          backgroundImage: `url(${back})`,
        }}
      >
        <h1 className="text-2xl sm:text-3xl font-bold text-blue-700">
          Concurrent and Statutory Bank Audit
        </h1>
        <p className="mt-2 max-w-3xl text-black font-semibold text-sm sm:text-lg lg:text-xl">
        Comprehensive Concurrent and Statutory Bank Audit Services with with Sanjay K Nathani & Co.        
         </p>
      </div>

      {/* Description Section */}
      <div className="mt-6 px-4 sm:px-6 lg:px-20">
        <p className="text-gray-700 leading-relaxed mb-6">
          Concurrent and statutory bank audits are critical to ensuring the financial health and operational efficiency of any financial institution. At Sanjay K Nathani & Co., we offer comprehensive concurrent and statutory bank audit services to help financial institutions maintain compliance with regulatory requirements and identify areas for improvement.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6">
        Our team of expert auditors has extensive experience in conducting concurrent and statutory bank audits for various financial institutions. Our concurrent and statutory bank audit services include:
        </p>

        {/* List of Services */}
        <ol className="list-disc list-inside space-y-2 text-gray-700">
          <li>Comprehensive review and analysis of financial and operational processes</li>
          <li>Identification of potential risks and weaknesses in internal controls</li>
          <li>Assessment of compliance with regulatory requirements</li>
          <li>Recommendations on process improvement and optimization strategies</li>
          <li>Preparation and submission of audit reports</li>
        </ol>

        <p className="text-gray-700 leading-relaxed mt-6">
        We use the latest technology and software to ensure that our concurrent and statutory bank audit services are accurate, efficient, and hassle-free. Our team of experts can provide you with customized solutions that cater to your specific business needs and compliance requirements.
</p>
      </div>

      {/* Contact Section */}
      <div className="mt-8 bg-gray-50 p-6 rounded-md shadow-sm px-4 sm:px-6 lg:px-20">
        <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-4">Get in touch</h2>
        <p className="text-gray-600 mb-6">
          If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-y-4 sm:gap-x-4">
          {/* Make Appointment Button */}
          <button
            onClick={handleAppointmentClick}
            className="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition duration-200"
          >
            Make Appointment
          </button>

          {/* Contact Us Button */}
          <button className="px-6 py-2 bg-[#005A8C] text-white rounded hover:bg-blue-600 transition duration-200">
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default Concurry;
